// generated by tools/build-laugh.py from Fred's laugh mp3
window.LAUGH_LEN = 1.9;
window.LAUGH_CADENCE = [0.06, 0.18, 0.31, 0.44, 0.6, 0.73, 0.88];
